<template>
  <div>
    <NewNavbar variant="signup" />
    <client-only>
      <div v-if="currentStep" class="signup-layout-steps min-h-2 relative lg:hidden z-50">
        <button
          v-if="!hideBackButton"
          class="px-10 pt-5 flex items-center text-gray-500 focus:outline-none lg:hidden"
          @click="onBackButtonClick"
        >
          <OSvg svg="arrow-left" class="fill-gray-500 w-3 mt-1" />
          <span class="ota-p14" v-text="$t('FormNavigation.Previous')" />
        </button>
        <div
          v-if="currentStep"
          class="min-h-2 relative lg:hidden z-50 px-10"
          :class="{ 'pt-5': hideBackButton }"
        >
          <Steps
            v-if="currentStep"
            :active-step="currentStep"
            :steps="signupSteps"
          />
        </div>
      </div>
    </client-only>
    <nuxt />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { unauthenticated } from '@/mixins/layouts'
import signupMixin from '@/mixins/signup'
import metaMixin from '@/mixins/meta'
const NewNavbar = () => import('@/components/NewNavbar')
const Steps = () => import('@/components/Steps')
const OSvg = () => import('@/components/OSvg')

export default {
  name: 'LayoutSignUp',
  components: {
    NewNavbar,
    Steps,
    OSvg
  },
  mixins: [unauthenticated, signupMixin(), metaMixin],
  computed: {
    hideBackButton () {
      return (this.currentStep === 5 || this.currentStep === 6) && this.form.paymentId
    },
    ...mapState('app', {
      country: state => state.country
    }),
    ...mapState('signup', {
      currentStep: state => state.currentStep
    })
  },
  head () {
    return {
      title: this.metaTitle
    }
  }
}
</script>

<style lang="postcss" scoped>
.min-h-2 {
  min-height: .8rem;
}

>>> .sticky-atc {
  @apply p-0;

   .obutton {
    @apply py-8 rounded-none !important;
    height: unset;
    min-height: 4rem;
  }
}

.men-signup-container {
  @apply min-h-screen;
}

.men-signup-scrollable-container {
  @apply relative h-full overflow-y-auto;
  min-height: calc(100vh - 10rem);
}

@media (max-width: 1023px) {
  .page-slide-left-enter-active, .page-slide-left-leave-active {
    @apply transition-all absolute duration-300 max-w-full;
  }

  .page-slide-left-enter {
    right: -100%;
  }

  .page-slide-left-enter-to {
    right: 0;
  }

  .page-slide-left-leave {
    left: 0;
  }

  .page-slide-left-leave-to {
    left: -100%;
  }

  .page-slide-right-enter-active, .page-slide-right-leave-active {
    @apply transition-all absolute duration-300 max-w-full;
  }

  .page-slide-right-enter {
    left: -100%;
  }

  .page-slide-right-enter-to {
    left: 0;
  }

  .page-slide-right-leave {
    right: 0;
  }

  .page-slide-right-leave-to {
    right: -100%;
  }
}

.fade-in-enter,
.fade-in-leave {
  @apply opacity-0;
}

.fade-in-enter-active,
.fade-in-leave-active {
  @apply transition-opacity duration-300 ease-out;
}
</style>
